import React from 'react'
import Swipeable from 'react-swipeable'

class Gallery extends React.Component {

  constructor(){
    super();

    this.state = {
      activeSlide:0,
      fullScreen:false,
      minHeight: 0
    }

    this.getHeight = this.getHeight.bind(this)
    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.toggleFullScreen = this.toggleFullScreen.bind(this)
  }


  componentWillMount(){
    this.getHeight();
  }

  nextSlide(){
    let activeSlide = (this.state.activeSlide + 1);
        (activeSlide > this.props.items.length-1)?
          activeSlide = 0
        : null ;

        this.setState({activeSlide})
  }
  prevSlide(){
    let activeSlide = (parseFloat(this.state.activeSlide) - 1);
        (activeSlide < 0)?
          activeSlide = this.props.items.length-1
        : null ;

        this.setState({activeSlide})
  }

  toggleFullScreen(){
      let fullScreen = !(this.state.fullScreen);
      this.setState({fullScreen})
  }

  hideMenuAndLogo(){
    //console.log(window.navigator.userAgent);

    if(window.navigator.userAgent.indexOf('iPhone') !==-1 || window.navigator.userAgent.indexOf('iPad') !==-1){
      console.log("Hack to HIDE logo and menu on iOS");
      document.querySelector('.main-menu').classList.add('hide');
      document.querySelector('.logo').classList.add('hide');
    }
  }
  showMenuAndLogo(){

      if(window.navigator.userAgent.indexOf('iPhone') !==-1 || window.navigator.userAgent.indexOf('iPad') !==-1){
        console.log("Hack to SHOW logo and menu on iOS");
        document.querySelector('.main-menu').classList.remove('hide');
        document.querySelector('.logo').classList.remove('hide');
      }
  }

  getHeight(){

    let minHeight=this.state.minHeight

      for(let i in this.refs){
        (this.refs[i].clientHeight > minHeight)? minHeight = this.refs[i].clientHeight : null
      }

    //console.log("Gallery Image minHeight",minHeight);

    (minHeight!==this.state.minHeight)?
      this.setState({minHeight})
    : null

  }

  render () {


    let fullscreenClass = (this.state.fullScreen)? 'fullscreen' : '' ;
    //let minHeight = (this.state.fullScreen)? '' : this.state.minHeight+'px'
    let minHeight = (this.state.fullScreen)? '' :  '320px';

    (this.state.fullScreen)?
      this.hideMenuAndLogo()
    :
     this.showMenuAndLogo()
    ;

    return(
      <div className={"gallery "+fullscreenClass}>

        <Swipeable className="images-wrapper" onSwipedLeft={this.nextSlide} onSwipedRight={this.prevSlide}>
          <div className="images" style={{minHeight}}>
            {this.props.items.map((item,index)=>{

                let activeClass = (index===this.state.activeSlide)? 'active' : 'not-active';
                let image = (this.state.fullScreen)? item.url : item.sizes.gallery_thumbnail

                //console.log(item.sizes);

                if(!this.state.fullScreen){
                  // Thumbs
                  return (<div key={'g'+index} onClick={this.toggleFullScreen}  className={"image "+activeClass}><img onLoad={this.getHeight} ref={'image'+index} src={image} /></div>)
                }else{
                  // Full Images
                  return (<div key={'g'+index}  className={"image "+activeClass}><img onLoad={this.getHeight} src={image} /></div>)
                }


            })}
          </div>

          {(this.props.items.length>1)?
            <div className="controls">
                <div className="next" onClick={this.nextSlide}></div>
                <div className="prev" onClick={this.prevSlide}></div>
            </div>
          : null
        }
        </Swipeable>
          <div className="indicator">
              {(this.props.items.length>1)?
                <span>
                {this.state.activeSlide+1} of {this.props.items.length}
                </span>
                : null }
          </div>

        <div className="full-screen-toggle" onClick={this.toggleFullScreen}>
        {
          (this.state.fullScreen)?
            <div className="close-button"></div>
          :
            <span>View Gallery</span>

        }
        </div>


      </div>
    )
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/modules/gallery/Gallery.js